"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _commonReact = require("@devsta/common-react");

var _SRTCaptions = _interopRequireDefault(require("./SRTCaptions"));

require("../styles/upload-video.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UploadVideo = /*#__PURE__*/function (_Component) {
  _inherits(UploadVideo, _Component);

  var _super = _createSuper(UploadVideo);

  function UploadVideo() {
    var _this;

    _classCallCheck(this, UploadVideo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "fetchCaptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getAsset, assetId, newAssetId, assetIdToUse, _yield$getAsset, data, error, assetFiles;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getAsset = _this$props.getAsset, assetId = _this$props.assetId;
              newAssetId = _this.state.newAssetId;
              assetIdToUse = newAssetId || assetId;

              _this.setState({
                loadingCaptions: true
              });

              _context.next = 6;
              return getAsset(assetIdToUse);

            case 6:
              _yield$getAsset = _context.sent;
              data = _yield$getAsset.data;
              error = _yield$getAsset.error;

              if (!(!data || error)) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: error || 'error'
              }));

            case 11:
              if (data.getAsset) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                loadingCaptions: false
              }));

            case 13:
              assetFiles = data.getAsset.assetFiles;

              _this.setState({
                loadingCaptions: false,
                existingSRTs: assetFiles.CAPTION || [],
                existingVTTs: assetFiles.VTT_CAPTION || []
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleFilesChange", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
        var _this$props2, addFileToQueue, addVideoSource, versionId, organisationId, file, assetId;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (files.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this$props2 = _this.props, addFileToQueue = _this$props2.addFileToQueue, addVideoSource = _this$props2.addVideoSource, versionId = _this$props2.versionId, organisationId = _this$props2.organisationId;
                file = files[files.length - 1];
                _context2.next = 6;
                return addFileToQueue({
                  file: file
                }, organisationId);

              case 6:
                assetId = _context2.sent;

                _this.setState({
                  newAssetId: assetId
                });

                _this._filePickerRef.removeFiles();

                addVideoSource({
                  versionId: versionId,
                  input: {
                    assetId: assetId
                  }
                });

                _this.fetchCaptions();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      if (_this._filePickerRef || !ref) {
        return;
      }

      _this._filePickerRef = ref;
    });

    return _this;
  }

  _createClass(UploadVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var assetId = this.props.assetId;

      if (assetId) {
        this.fetchCaptions();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          newAssetId = _this$state.newAssetId,
          existingSRTs = _this$state.existingSRTs,
          existingVTTs = _this$state.existingVTTs,
          loadingCaptions = _this$state.loadingCaptions,
          error = _this$state.error;

      if (error) {
        return null;
      }

      var _this$props3 = this.props,
          assetId = _this$props3.assetId,
          appliedAddons = _this$props3.appliedAddons,
          organisationId = _this$props3.organisationId,
          getAsset = _this$props3.getAsset,
          createFile = _this$props3.createFile,
          updateFile = _this$props3.updateFile,
          apolloClient = _this$props3.apolloClient;
      var assetIdToUse = newAssetId || assetId;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "upload-video"
        }, /*#__PURE__*/_react.default.createElement(_reactFiles.default, {
          onChange: this.handleFilesChange,
          accepts: ['video/*'],
          minFileSize: 1,
          clickable: true,
          ref: this.setFilePickerRef
        }, assetIdToUse ? /*#__PURE__*/_react.default.createElement("p", {
          className: "upload-video__text"
        }, "Browse for file") : /*#__PURE__*/_react.default.createElement("div", {
          className: "upload-video__box"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "upload-video__text"
        }, "Browse for file"))), assetIdToUse && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
          canPlayVideo: true,
          assetId: assetIdToUse
        }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
          className: "output__configure__srt-title"
        }, "SRT Captions"), loadingCaptions ? null : /*#__PURE__*/_react.default.createElement(_SRTCaptions.default, {
          appliedAddons: appliedAddons,
          getAsset: getAsset,
          createFile: createFile,
          updateFile: updateFile,
          organisationId: organisationId,
          assetId: assetIdToUse,
          existingSRTs: existingSRTs,
          existingVTTs: existingVTTs,
          disabled: false,
          apolloClient: apolloClient
        })))
      );
    }
  }]);

  return UploadVideo;
}(_react.Component);

var _default = UploadVideo;
exports.default = _default;